import { useEffect, useState } from 'react';
import type { FactorsData } from '@shared/factors';
import { api } from './api';

let cache: FactorsData | null = null;
let inflight: Promise<FactorsData> | null = null;

export async function loadFactors(): Promise<FactorsData> {
  if (cache) return cache;
  if (!inflight) {
    inflight = api.get<FactorsData>('/api/factors').then((d) => {
      cache = d;
      return d;
    });
  }
  return inflight;
}

export function useFactors() {
  const [data, setData] = useState<FactorsData | null>(cache);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (cache) {
      setData(cache);
      return;
    }
    let cancelled = false;
    loadFactors()
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch((e) => {
        if (!cancelled) setError(e instanceof Error ? e : new Error(String(e)));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading: data === null && !error, error };
}
